import { useSelector } from 'react-redux'
import { CondorcetSelectorStateful } from './components/CondorcetSelector.jsx'
import { CopyBtnStateful } from './components/CopyBtn.jsx'
import { MessageOutputStateful } from './components/Output.jsx'
import { selectIsStateValid } from './stores/store.js'

export function App() {
  const isStateValid = useSelector(selectIsStateValid)

  return <div className="font-sans bg-gray-100">
    <div className="min-h-screen mx-auto p-2" style={{ maxWidth: "700px" }}>
      <div className="stack">
        <div>
          <CondorcetSelectorStateful />
        </div>
        <div>
          { isStateValid ? <div className="text-green-600">
            C'est bon ! (Vous pouvez ceci-dit continuer, ou éditer votre sélection)
            </div> : <div className="text-red-600">
            Il reste des candidats à classer
          </div> }
          <MessageOutputStateful />
          <div className="flex flex-row-reverse">
            <CopyBtnStateful />
          </div>
        </div>
      </div>
    </div>
  </div>
}
